
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cancellation-terms-policies",
      function () {
        return require("private-next-pages/cancellation-terms-policies.js");
      }
    ]);
  